import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';


import {TranslateModule} from '@ngx-translate/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {PrivatePage} from "./private.page";
// import {Dashboard} from "./dashboard/dashboard";
// import {RunningtransactionService} from "./dashboard/runningtransaction.service";
import {Finance} from "./finance/finance";
import {FinanceService} from "./finance/finance.service";
import {NgxStripeModule} from "@nomadreservations/ngx-stripe";
import {Charge} from "./charge/charge";
import {ConnectorsService} from "./charge/connectors.service";
import {StationsService} from "./charge/stations.service";
// import {TransactionreportService} from "./dashboard/transactionreport.service";
import {SharedUserService} from "../shared/_services/shareduser.service";
import {SharedNavigationService} from "../shared/_services/sharednavigation.service";
import {PaymentWalletIntentService} from "./finance/paymentWalletIntent.service";
// import {ChargesessionService} from "./dashboard/chargesession.service";
import {HelpService} from "./profile/help/help.service";
import {ChargesessionService} from "./reporting/chargesession.service";
import {TransactionreportService} from "./reporting/transactionreport.service";
import {RunningtransactionService} from "./reporting/runningtransaction.service";
import {Payments} from "./payments/payments";
import {PaymentsService} from "./payments/payments.service";
import {TagsService} from "./profile/tags/tags.service";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule,
        FontAwesomeModule,
        NgxStripeModule,
        ReactiveFormsModule
    ],
    declarations: [
        PrivatePage,
        // Dashboard,
        Finance,
        Charge,
        //Rfid,
         Payments,
        // OnRouteComponent,

    ],

    providers: [
        RunningtransactionService,
        FinanceService,
        StationsService,
        ConnectorsService,
        TransactionreportService,
        SharedUserService,
        SharedNavigationService,
        PaymentWalletIntentService,
        ChargesessionService,
        HelpService,
        PaymentsService,
        TagsService

    ]


})
export class PrivatePageModule {
}
